import { LitElement, css, html } from "lit"
import { unsafeHTML } from "lit/directives/unsafe-html.js"
import { when } from "lit/directives/when.js"
const { apiFetch } = window.wp

export class VatToggle extends LitElement {
	static properties = {
		display_vat: { type: Boolean },
		is_set: { type: Boolean },
		inline: {
			type: Boolean,
			// custom converter so attribute values like "false" are respected
			converter: {
				fromAttribute: value => {
					// attribute absent -> false
					if (value === null) return false
					// treat empty string, "true" or "1" as true; "false" or "0" as false
					return value === "" || value === "true" || value === "1"
				},
				toAttribute: value => (value ? "" : null),
			},
		},
	}

	constructor() {
		super()
		this.display_vat = false
		this.inline = false
	}

	// style as modal with one b

	getCookie(name) {
		const value = `; ${document.cookie}`
		const parts = value.split(`; ${name}=`)
		if (parts.length === 2) return parts.pop().split(";").shift()
	}

	connectedCallback() {
		super.connectedCallback()

		const cookie = this.getCookie("cirkularfabriken_display_vat")
		if (cookie) {
			this.display_vat = cookie === "1"
		}

		this.is_set = !!cookie
	}

	static styles = css`
		.wrap {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.6);
			display: flex;
			align-items: center;
			justify-content: center;
			z-index: 1000;
		}

		.modal {
			background: white;
			border-radius: 8px;
			padding: 2rem;
			width: 90%;
			max-width: 600px;
			text-align: center;
			box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
			position: relative;
			font-family: Arial, sans-serif;
		}

		.wrapper {
			position: relative;
		}

		.title {
			font-size: 24px;
			font-style: normal;
			font-weight: 900;
			line-height: 120%; /* 28.8px */
			letter-spacing: -0.48px;
			margin: 2rem 0;
			text-align: left;
			color: #1c1e1d;
		}

		.modal button {
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 100%;
			padding: 0.75rem 1rem;
			font-weight: 700;
			border-radius: 6px;
			border: 2px solid transparent;
			cursor: pointer;
			font-size: 0.95rem;
			transition:
				background-color 0.3s,
				color 0.3s,
				border-color 0.3s;
		}

		.company {
			background-color: #4b883c;
			color: white;
			margin-bottom: 0.75rem;
		}

		.company:hover {
			background-color: #3c6930;
		}

		.private {
			background-color: white;
			color: #4b883c;
			border-color: #4b883c;
		}

		.private:hover {
			background-color: #4b883c;
			color: white;
			border-color: transparent;
		}

		.arrow {
			font-size: 1.2rem;
		}

		.modal button.close {
			position: absolute;
			top: -1.75rem;
			right: -0.75rem;
			background: none;
			border: none;
			font-size: 1.2rem;
			cursor: pointer;
			width: 30px;
			padding: 0;
			width: 30px;
			height: 30px;
		}

		.inline-company,
		.inline-private,
		.inline-avtalskund {
			color: #fff;
			opacity: 0.7;
			/* Body/Desktop__S */
			font-family: var(--Font-Family-Body, Hind);
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 140%; /* 22.4px */
			letter-spacing: 0.16px;

			background-color: transparent;
			border: none;
			cursor: pointer;
			outline: none;
		}

		.inline-company.selected,
		.inline-private.selected,
		.inline-avtalskund.selected {
			color: #fff;
			opacity: 1;
			/* Body/Desktop__S */
			font-family: var(--Font-Family-Body, Hind);
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 140%; /* 22.4px */
			letter-spacing: 0.16px;
			text-decoration-line: underline;
			text-decoration-style: solid;
			text-decoration-skip-ink: none;
			text-decoration-thickness: 7.5%; /* 1.2px */
			text-underline-offset: 25%; /* 4px */
			text-underline-position: from-font;
		}
	`

	render() {
		if (this.is_set && !this.inline) {
			this.style.display = "none"
			return html``
		}

		if (this.inline) {
			const current =
				this.getCookie("cirkularfabriken_customer_type") || "privat"
			return html`
				<button
					class="inline-company ${current === "företag" ? "selected" : ""}"
					@click=${() => this._select("företag")}>
					Företag
				</button>
				<button
					class="inline-private ${current === "privat" ? "selected" : ""}"
					@click=${() => this._select("privat")}>
					Privat
				</button>
				<button
					class="inline-avtalskund ${current === "avtalskund"
						? "selected"
						: ""}"
					@click=${() => this._select("avtalskund")}>
					Avtalskund
				</button>
			`
		}

		return html`
			<div class="wrap">
				<div class="modal">
					<div class="wrapper">
						<button class="close" @click=${this._close}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="45"
								height="29"
								viewBox="0 0 45 29"
								fill="none">
								<rect
									x="12.1445"
									y="23.6296"
									width="27.8571"
									height="1.42857"
									transform="rotate(-45 12.1445 23.6296)"
									fill="#1C1E1D" />
								<rect
									x="13.1562"
									y="3.93164"
									width="27.8571"
									height="1.42857"
									transform="rotate(45 13.1562 3.93164)"
									fill="#1C1E1D" />
							</svg>
						</button>
						<div class="title">Vänligen välj företag eller privat</div>
						<button class="company" @click=${() => this._select("företag")}>
							FÖRETAG <span class="arrow">→</span>
						</button>
						<button class="private" @click=${() => this._select("privat")}>
							PRIVAT <span class="arrow">→</span>
						</button>
						<button
							class="avtalskund"
							@click=${() => this._select("avtalskund")}>
							AVTALSKUND <span class="arrow">→</span>
						</button>
					</div>
				</div>
			</div>
		`
	}

	_close() {
		this.style.display = "none"
	}

	_select(type) {
		const display_vat = type === "företag" || type === "avtalskund" ? "0" : "1"
		document.cookie = `cirkularfabriken_display_vat=${display_vat}; path=/; max-age=${60 * 60 * 24 * 30}; SameSite=Lax`
		document.cookie = `cirkularfabriken_customer_type=${type}; path=/; max-age=${60 * 60 * 24 * 30}; SameSite=Lax`
		this.style.display = "none"
		location.reload()
	}
}
